import { HeroIcon } from '@clarke-energia/foton-v2';
import { IconName } from '@clarke-energia/foton-v2';
import { useState, useEffect } from 'react';
import { ToastContainerProps, ToastItem, ToastPosition, ToastType } from './types';
import { toastStore } from './store';

const toastTypeStyles: Record<
  ToastType,
  {
    border: string;
    icon: IconName;
    iconColor: string;
  }
> = {
  success: {
    border: 'border-green-500',
    icon: 'CheckCircleIcon',
    iconColor: 'text-primary-70',
  },
  error: {
    border: 'border-red-500',
    icon: 'XCircleIcon',
    iconColor: 'text-orange-60',
  },
  warning: {
    border: 'border-yellow-500',
    icon: 'ExclamationTriangleIcon',
    iconColor: 'text-yellow-500',
  },
  info: {
    border: 'border-blue-500',
    icon: 'InformationCircleIcon',
    iconColor: 'text-blue-60',
  },
};

const positionClasses: Record<ToastPosition, string> = {
  'top-left': 'top-5 left-5 items-start',
  'top-right': 'top-5 right-5 items-end',
  'bottom-left': 'bottom-5 left-5 items-start',
  'bottom-right': 'bottom-5 right-5 items-end',
  'top-center': 'top-5 left-1/2 transform -translate-x-1/2 items-center',
  'bottom-center': 'bottom-5 left-1/2 transform -translate-x-1/2 items-center',
};

export const ToastContainer = ({ position = 'bottom-right' }: ToastContainerProps) => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const unsubscribe = toastStore.subscribe(setToasts);
    return () => unsubscribe();
  }, []);

  return (
    <div className={`fixed z-50 flex flex-col gap-3 my-5 ${positionClasses[position]}`}>
      {toasts.map((toast) => {
        const { border, icon, iconColor } = toastTypeStyles[toast.type];

        return (
          <div
            key={toast.id}
            className={`flex gap-5 items-center border-l-4 shadow-md w-fit max-w-8/12 h-10 p-8 bg-white rounded-[1.25rem] ${border}`}
          >
            <HeroIcon icon={icon} className={`w-10 h-10 p-4 ${iconColor}`} />

            <span className="max-w-sm text-sm">{toast.message}</span>

            <HeroIcon
              icon="XMarkIcon"
              className="p-2 ml-auto w-6 h-6 text-gray-500 border border-gray-500 cursor-pointer hover:text-gray-700 rounded-pill"
              onClick={() => toastStore.removeToast(toast.id)}
            />
          </div>
        );
      })}
    </div>
  );
};
